import * as React from "react"
import { useRecoilValue } from "recoil"
import { Flex } from "@chakra-ui/react"
import { LocalUserProperties } from "../../types/localUserProps"
import { StyledResizableBox } from "../common/resizableBox"
import { MobileServicePanel } from "../mediaPanel/small-view/mobile-service-panel"
import useWindowSize from "../../hooks/useWindowSize"
import { usersListSmallWindowSelector } from "../../recoil/atoms/userListSmallWindow"

interface TableServicePanelProps {
  localUserProperties: LocalUserProperties
  heightMainScreenContainer: number
  heightPrevSpeaker: number
  widthMainScreen: number
}

const _TableServicePanel: React.FC<TableServicePanelProps> = ({
  localUserProperties,
  heightMainScreenContainer,
  heightPrevSpeaker,
  widthMainScreen
}) => {
  const [chatSize, setChatSize] = React.useState({ width: 0, height: 0 })
  const userIdsSmallWindows = useRecoilValue(usersListSmallWindowSelector)
  const { screenSize } = useWindowSize()

  const isFullWidth = React.useMemo(
    () =>
      userIdsSmallWindows.length === 0 &&
      widthMainScreen >= screenSize.width - 2,
    [userIdsSmallWindows, screenSize.width, widthMainScreen]
  )

  const gapBetweenMainScreenAndChat = React.useMemo(() => {
    if (isFullWidth) {
      return 0
    }
    if (userIdsSmallWindows.length === 0) {
      return 20
    }
    return 30
  }, [isFullWidth, userIdsSmallWindows.length])

  const chatSizeDefault = React.useMemo(() => {
    return {
      width: screenSize.width,
      height:
        screenSize.height -
        heightMainScreenContainer -
        heightPrevSpeaker -
        gapBetweenMainScreenAndChat
    }
  }, [
    gapBetweenMainScreenAndChat,
    heightMainScreenContainer,
    heightPrevSpeaker,
    screenSize.height,
    screenSize.width
  ])

  const handleSize = React.useMemo(
    () => [screenSize.width, screenSize.height],
    [screenSize.height, screenSize.width]
  )

  React.useEffect(() => {
    setChatSize(chatSizeDefault)
  }, [chatSizeDefault])

  return (
    <Flex position="absolute" bottom="0px">
      <StyledResizableBox
        width={chatSize.width}
        height={chatSize.height}
        handleSize={handleSize}
        resizeHandles={["n"]}
        axis={"y"}
        mb="0"
      >
        <MobileServicePanel
          
          localUserProperties={localUserProperties}
          hideTabs={false}
          isTablet={true}
          chatSize={chatSize}
        />
      </StyledResizableBox>
    </Flex>
  )
}

export const TableServicePanel = React.memo(_TableServicePanel)
